import { Box, type BoxProps } from "@chakra-ui/react";
import Image, { type StaticImageData } from "next/image";
import React from "react";
import { ChakraBox } from "ui/chakra-framer";

const fadeInVariants = {
  hidden: { opacity: 0, scale: 0.95, y: 10, transition: { duration: 0.7 } },
  visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.7 } },
};

export type BackgroundImageProps = {
  isInView?: boolean;
  imageUrl: StaticImageData;
  imageAlt: string;
};

export function BackgroundImage({ isInView, imageUrl, imageAlt, ...props }: BackgroundImageProps & BoxProps) {
  return (
    <Box pos="absolute" inset={0} {...props}>
      <ChakraBox
        pos="relative"
        boxSize="100%"
        variants={fadeInVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        exit="hidden"
      >
        <Image
          priority
          fill
          sizes="100%"
          src={imageUrl}
          alt={imageAlt}
          style={{ objectFit: "cover", objectPosition: "bottom center" }}
        />
      </ChakraBox>
    </Box>
  );
}
